<template>
  <div class="course-menu gh-credential-learning-sidebar">
    <el-menu
      :defaultActive="defaultActive"
      :defaultOpeneds="defaultOpened"
      :uniqueOpened="true"
      @select="handleSelect"
      class="gh-sidebar__menu"
      ref="menu">
      <!-- Back To My Classroom -->
      <el-menu-item index="back" class="is-teal">
        <router-link class="gh-menu__item" to="/dashboard/credential/catalogue">
          <span class="gh-menu__label">Back to Credential Courses</span>
        </router-link>
      </el-menu-item>

      <el-collapse :value="+moduleOrder" accordion class="gh-modules">
        <el-collapse-item
          v-for="memberModule in memberModules"
          :key="memberModule.id"
          :name="memberModule.module.orderIndex"
          :disabled="!memberModule.accessibleAt"
          class="gh-module"
        >
          <template slot="title">
            <div v-if="memberModule.accessibleAt" class="gh-title">
              <span class="gh-title-label">Module {{ memberModule.module.orderIndex }}</span>
              <i v-if="!memberModule.accessibleAt" class="gh-title-icon fa fa-lock"></i>
            </div>
            <el-popover
              v-else
              placement="left-start"
              width="250"
              trigger="hover"
              class="gh-title"
              content="To unlock this module, you must complete all previous modules.">
              <div slot="reference">
                <span class="gh-title-label">Module {{ memberModule.module.orderIndex }}</span>
                <i class="gh-title-icon fa fa-lock"></i>
              </div>
            </el-popover>
          </template>
          <div v-if="memberModule.accessibleAt">
            <router-link v-show="hasManyUnits(memberModule)" class="gh-menu__item" :to="getModuleRoute(memberModule)">
              <strong class="gh-menu__label">Overview</strong>
            </router-link>
            <div v-for="memberUnit in memberModule.units" :key="memberUnit.id" class="gh-module-unit">
              <router-link class="gh-menu__item" :to="getUnitRoute(memberUnit, memberModule)">
                <strong class="gh-menu__label">Unit {{ memberUnit.unit.orderIndex }} (Resources)</strong>
              </router-link>
              <router-link class="gh-menu__item" :to="getUnitAssessmentRoute(memberUnit, memberModule)">
                <span class="gh-menu__label">Assessment {{ memberUnit.unit.orderIndex }}</span>
                <i :class="assessmentIcon(memberUnit.completedAt)"></i>
              </router-link>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-menu>

    <div class="gh-progress">
      <div class="gh-title">Assessment Progress</div>
      <div class="gh-progress-percentage">{{ completedAssessments.length }} out of {{ totalAssessments.length }} ({{ percentage }}%)</div>
      <div>Units Completed</div>
      <div class="gh-progress-bar">
        <el-progress :text-inside="false" :stroke-width="25" :percentage="percentage" :show-text="false"/>
        <span class="gh-progress-text">{{ percentage }}% Completed</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      memberCourse: {
        type: Object,
        required: true
      },

      moduleOrder: {
        type: [String, Number],
        default: 1
      }
    },

    computed: {
      defaultOpened() {
        return [this.$route.path.substr(this.$route.path.indexOf('modules'))];
      },

      defaultActive() {
        return this.$route.path.substr(this.$route.path.indexOf('modules'))
      },

      isTouch() {
        return this.$store.state.ui.isTouch;
      },

      memberModules () {
        return _.toArray(this.memberCourse.modules)
      },

      totalAssessments () {
        return _.flatMap(this.memberModules, item => _.toArray(item.units))
      },

      completedAssessments () {
        return this.totalAssessments.filter(item => item.completedAt)
      },

      percentage () {
        return Math.round(100 * this.completedAssessments.length / this.totalAssessments.length)
      }
    },

    methods: {
      handleSelect(index, indexPath) {
        this.openModuleMenu()

        this.isTouch && this.$store.commit('ui/TOGGLE_SIDEBAR_VISIBILITY_ON_MOBILE');
      },

      openModuleMenu (order) {
        const index = order ? `modules/${order}` : `modules/${this.moduleOrder}`

        this.$refs.menu && this.$refs.menu.open(index)
      },

      getModuleRoute (module) {
        return {
          name: 'memberDashboard.credential.course.module',
          params: {
            moduleOrder: module.module.orderIndex
          }
        }
      },

      getUnitRoute (memberUnit, module) {
        return {
          name: 'memberDashboard.credential.course.module.unit',
          params: {
            moduleOrder: module.module.orderIndex,
            unitOrder: memberUnit.unit.orderIndex
          }
        }
      },

      getUnitAssessmentRoute (memberUnit, module) {
        return {
          name: 'memberDashboard.credential.course.module.unit.assessment',
          params: {
            moduleOrder: module.module.orderIndex,
            unitOrder: memberUnit.unit.orderIndex
          }
        }
      },

      assessmentIcon (completed) {
        return [
          'fa',
          completed ? 'fa-check-circle color-success' : 'fa-pencil'
        ]
      },

      hasManyUnits (module) {
        return Object.keys(module.units).length > 1
      }
    }
  }
</script>

<style lang="scss">
  .gh-credential-learning-sidebar {
    .gh-modules {
      margin-top: 1rem;
    }

    .gh-module {
      + .gh-module {
        margin-top: 1rem;
      }
    }

    .el-collapse-item__header {
      padding: 1rem;

      &.is-active {
        .gh-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #085078;
        }
      }
    }

    .el-collapse-item.is-disabled .el-collapse-item__header {
      cursor: initial;
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    .gh-menu__item {
      padding: .5rem 1rem;
      color: #565A60;
      transition: border .3s;

      &:hover {
        background:#F2F2F2;
      }

      &.router-link-exact-active {
        background: #E5E5E5;
        border-left: 5px solid #514A9D;
        font-weight: 700;
        color: #514A9D;
      }
    }

    .gh-title {
      width: 100%;
      font-size: 1.1rem;

      .el-popover__reference {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        font-size: 1.1rem;
        color: #828F9A;
      }
    }

    .gh-progress {
      margin-top: 1rem;
      padding: 1rem;
      background: #fff;
      color: #565A60;
      font-weight: 600;

      .gh-title {
        font-size: 1.3rem;
        font-weight: 700;
        color: #085078;
      }
    }

    .gh-progress-percentage {
      color: #514a9d;
      font-weight: 700;
    }

    .gh-progress-bar {
      position: relative;
      margin-top: 1rem;
    }

    .gh-progress-text {
      position: absolute;
      top: 50%;
      left: 50%;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      text-shadow: 0 0 3px #000;
      transform: translate3d(-50%, -50%, 0);
    }

    .el-progress-bar__outer {
      height: 30px !important;
      background: linear-gradient(to bottom, #E2DEE4, #CCD6DB);
      box-shadow: inset 0px 3px 7px -4px #92A8B3;
    }

    .el-progress-bar__inner {
      height: 85%;
      top: 50%;
      transform: translate3d(2px, -50%, 0);
      background: #92A8B3;
      box-shadow: inset 8px 23px 5px -21px white;
      text-align: center;
    }

    .color-success {
      color: #40B1B7
    }
  }
</style>
